module.exports = __webpack_public_path__ + "img/analytics.c4d0ef20.svg";